import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SearchBookIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 28.55 30.41"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 30.41)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13.06 29H3.78A2.78 2.78 0 0 1 1 26.22" />
      <path d="M23.43 10.34v-8.4a.93.93 0 0 0-.94-.94H4.74A3.74 3.74 0 0 0 1 4.74V26.2a2.8 2.8 0 0 1 2.8-2.8h4.67" />
      <path d="M11.36 19.72a6.5 6.5 0 1 0 6.5-6.5 6.5 6.5 0 0 0-6.5 6.5Z" />
      <path d="m27.13 29-4.68-4.69" />
    </SVG>
  );
};
